import { Arrays } from "src/modules/utils/shared/arrays";
import { ListenerCallback, ListenerCallbackInfo } from "./listener-callback-info.model";
import { Subscription } from "./subscription.model";

export class Listener<T>
{
    private listeners: ListenerCallbackInfo<T>[] = [];

    subscribe(callback: ListenerCallback<T> | ListenerCallbackInfo<T>, title?: string, priority = 0): Subscription
    {
        let info: ListenerCallbackInfo<T>;

        if (callback instanceof ListenerCallbackInfo)
        {
            info = callback;
        }
        else
        {
            info = new ListenerCallbackInfo<T>(callback, title, priority);
        }

        this.listeners.push(info);
        this.listeners = Arrays.sortBy(this.listeners, x => x.priority);

        return new Subscription(() => {
            this.listeners = this.listeners.filter(x => x !== info);
        });
    }

    async emit(data: T): Promise<void> {
        let copy = [...this.listeners];

        for (let listener of copy)
        {
            await listener.callback(data);
        }
    }

    clear(): void
    {
        this.listeners = [];
    }
}